import React from 'react';
import { Layout } from '../components/Layout';
export function SmsPolicy() {
  return <Layout data-id="element-149">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-150">
        <h1 className="text-3xl font-bold text-[#0A1D37] mb-8" data-id="element-151">
          SMS Opt-In Policy
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-152">
          <p className="text-gray-600 mb-8" data-id="element-153">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
          <section className="mb-10" data-id="element-154">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-155">
              Consent to Receive SMS Messages
            </h2>
            <p className="mb-4" data-id="element-156">
              By providing your phone number and submitting any form on our
              website, you consent to receive SMS messages from Forgepoint
              Management LLC. These messages may include appointment reminders,
              property offers, and updates related to your inquiry.
            </p>
            <div className="bg-[#E2E8F0] p-5 rounded-lg border-l-4 border-[#10B981] mb-6" data-id="element-157">
              <p className="text-[#4A5568] italic" data-id="element-158">
                "By providing your phone number and submitting this form, you
                consent to receive SMS messages from Forgepoint Management LLC.
                These messages may include appointment reminders, property
                offers, and updates related to your inquiry."
              </p>
            </div>
          </section>
          <section className="mb-10" data-id="element-159">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-160">
              Message Frequency
            </h2>
            <p className="mb-4" data-id="element-161">
              You may receive a maximum of 3 messages per week from Forgepoint
              Management LLC. The frequency of messages will depend on your
              interaction with our services and the status of your property
              inquiry or transaction.
            </p>
          </section>
          <section className="mb-10" data-id="element-162">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-163">
              Message and Data Rates
            </h2>
            <p className="mb-4" data-id="element-164">
              Message and data rates may apply to any SMS messages sent to or
              from Forgepoint Management LLC. If you have any questions about
              your text plan or data plan, it is best to contact your wireless
              provider. Forgepoint Management LLC is not responsible for any
              charges incurred by you for SMS messages.
            </p>
          </section>
          <section className="mb-10" data-id="element-165">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-166">
              How to Opt Out
            </h2>
            <p className="mb-4" data-id="element-167">
              You can unsubscribe from our SMS messages at any time by replying
              "STOP" to any message you receive from us. After you send the SMS
              message "STOP" to us, we will send you an SMS message to confirm
              that you have been unsubscribed. After this, you will no longer
              receive SMS messages from us.
            </p>
            <p className="mb-4" data-id="element-168">
              If you want to join again, you can sign up as you did the first
              time, and we will start sending SMS messages to you again.
            </p>
          </section>
          <section className="mb-10" data-id="element-169">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-170">
              Help and Support
            </h2>
            <p className="mb-4" data-id="element-171">
              If you need assistance with our SMS messaging service, you can:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-172">
              <li data-id="element-173">Reply "HELP" to any message we send you</li>
              <li data-id="element-174">Email us at info@forgepointmanagement.com</li>
              <li data-id="element-175">Call us at (555) 123-4567</li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-176">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-177">
              Changes to this SMS Policy
            </h2>
            <p className="mb-4" data-id="element-178">
              Forgepoint Management LLC reserves the right to modify this SMS
              Policy at any time. Any changes to this SMS Policy will be posted
              on this page with an updated effective date.
            </p>
            <p className="mb-4" data-id="element-179">
              By continuing to use our services and receive SMS messages from us
              after we post any modifications to this SMS Policy, you agree to
              be bound by the revised policy.
            </p>
          </section>
          <section data-id="element-180">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-181">
              Contact Us
            </h2>
            <p className="mb-4" data-id="element-182">
              If you have any questions about this SMS Policy or our SMS
              messaging practices, please contact us at:
            </p>
            <div className="bg-[#E2E8F0] p-4 rounded-lg" data-id="element-183">
              <p className="mb-1" data-id="element-184">
                <strong data-id="element-185">Forgepoint Management LLC</strong>
              </p>
              <p className="mb-1" data-id="element-186">Email: info@forgepointmanagement.com</p>
              <p className="mb-1" data-id="element-187">Phone: (555) 123-4567</p>
            </div>
          </section>
        </div>
      </div>
    </Layout>;
}